import { tabProps } from "@/utils/globalPropsTypes";
import { DatePicker, Form, Input, InputNumber, Radio, Select, Switch } from "antd";
import { Col, Row } from "react-bootstrap";

const intervalOptions = [
  { label: "Real Time", value: "" },
  { label: "Minute", value: 1 },
  { label: "Hour", value: 60 },
  { label: "Day", value: 1440 },
  { label: "Monthly", value: 43830 },
  { label: "Yearly", value: 525960 },
];

const { RangePicker } = DatePicker;
function TimeFrameTab({ editItem, form }) {
  return (
    <>
      {editItem?.component === "comboBar" ? (
        <>
          <div>
            <div className="fw-bold mb-2">Line Chart:</div>
            <TimeSection prefix="line" {...{ editItem, form }} />
          </div>

          <div className="mt-5">
            <div className="fw-bold mb-2">Bar Chart:</div>
            <TimeSection prefix="bar" {...{ editItem, form }} />
          </div>
        </>
      ) : (
        <TimeSection prefix="" {...{ editItem, form }} />
      )}
    </>
  );
}

export default TimeFrameTab;

TimeFrameTab.propTypes = tabProps;

const TimeSection = ({ prefix = "", editItem, form }) => {
  const key = (name) => {
    const capitalized = name.charAt(0).toUpperCase() + name.slice(1);
    const camelCased = name.charAt(0).toLowerCase() + name.slice(1);
    return !prefix ? camelCased : `${prefix}${capitalized}`;
  };

  const intervalTime = editItem?.[key("IntervalTime")];
  const xAxis = editItem?.[key("XAxis")];
  const lastXDays = editItem?.[key("LastXDays")];

  return (
    <>
      {/* Interval */}
      <Row>
        <Col xs={6}>
          <Form.Item label="Select Interval" name={key("IntervalTime")}>
            <Select
              showSearch
              placeholder="Select Interval "
              onChange={(value) => {
                if (!value) {
                  form.setFieldsValue({
                    [key("Operator")]: undefined,
                    [key("IntervalValue")]: undefined,
                  });
                }
              }}
              options={intervalOptions}
            />
          </Form.Item>
        </Col>

        <Col xs={6}>
          {!!intervalTime && (
            <Form.Item label="Interval Value" name={key("IntervalValue")}>
              <InputNumber className="w-100" placeholder="Enter Value" controls={false} />
            </Form.Item>
          )}
        </Col>
      </Row>

      {/* Time Period */}
      <Form.Item label="Select Time Period" name={key("XAxis")}>
        <Radio.Group className="d-flex">
          {[
            { label: "Daily", value: "day" },
            { label: "Weekly", value: "week" },
            { label: "Monthly", value: "month" },
            { label: "Yearly", value: "year" },
            { label: "Custom", value: "custom" },
          ].map(({ label, value }) => (
            <Radio.Button key={value} className="w-100 text-center text-capitalize" value={value}>
              {label}
            </Radio.Button>
          ))}
        </Radio.Group>
      </Form.Item>

      {/* Custom */}
      {xAxis === "custom" && (
        <>
          <Form.Item name={key("LastXDays")} label="Last X Day">
            <Switch />
          </Form.Item>

          {lastXDays ? (
            <Form.Item name={key("LastXDaysValue")}>
              <Input type="number" placeholder="Input Last X Days Number" />
            </Form.Item>
          ) : (
            <Form.Item name={key("timeRange")} label="Select Time">
              <RangePicker showTime />
            </Form.Item>
          )}
        </>
      )}

      {/* Operator */}
      {!!intervalTime && (
        <Form.Item label="Select Operator" name={key("Operator")}>
          <Radio.Group>
            {[
              { label: "Maximum", value: "max" },
              { label: "Minimum", value: "min" },
              { label: "Average", value: "avg" },
              { label: "Sum", value: "sum" },
            ].map(({ label, value }) => (
              <Radio key={value} value={value} className="text-capitalize">
                {label}
              </Radio>
            ))}
          </Radio.Group>
        </Form.Item>
      )}
    </>
  );
};

TimeSection.propTypes = tabProps;
